import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Divider from '@material-ui/core/Divider'
import Button from '@material-ui/core/Button'
import Search from '@material-ui/icons/Search'
import { Grid } from '@material-ui/core'
import * as utils from '@utils'
import Table from '@tables/table'
import { API } from '@const'
import DateSelect from '@select/date-from-to-select'

class RiskmgtLogPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'RiskmgtLogPage')
        }
    }

    state = {
        gameOptionMap: {},
        isLoading: false,
    }

    columns = [
        {
            field: 'created_at',
            type: 'datetime',
        },
        {
            field: 'game_name',
            render: (rowData) => {
                const gameOption = this.state.gameOptionMap[rowData['oid']]

                return gameOption
                    ? gameOption['oid'] +
                          ': ' +
                          this.t('GameName.' + gameOption['game_code']) +
                          ' (' +
                          this.t('RoomType.' + gameOption['room_type_code_id']) +
                          ')'
                    : ''
            },
        },
        {
            field: 'round_id',
        },
        {
            field: 'risk_info_apply_type',
            translate: {
                dataKey: 'risk_info_apply_type',
                tranKey: 'RiskInfoApplyType',
            },
        },
    ]

    componentDidMount() {
        utils.apiRequest(
            'get',
            API.GAME_OPTION_LIST,
            {},
            (data) => {
                this.setState({ gameOptionMap: data })
            },
            () => {},
            true
        )
    }

    queryData() {
        this.table.SetLoading(true)

        utils.apiRequest(
            'get',
            API.RISKMGT_LOG_LIST,
            {
                start_at: utils.datetimeToUnix_startOf(this.dateSelect.state.startDate),
                end_at: utils.datetimeToUnix_endOf(this.dateSelect.state.endDate),
            },
            (data) => {
                this.table.SetData(data)
                this.setState({ isLoading: false })
            },
            (_err) => {
                this.table.SetData([])
                this.setState({ isLoading: false })
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <DateSelect onRef={(ref) => (this.dateSelect = ref)}></DateSelect>
                <Grid item xs={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={this.props.classes.button}
                        onClick={() => {
                            this.setState({ isLoading: true })
                            this.queryData()
                        }}
                        disabled={this.state.isLoading}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table
                        ownerName="RiskmgtLogPage"
                        columns={this.columns}
                        options={{ export: true, orderDirection: 'desc' }}
                        onRef={(ref) => (this.table = ref)}
                    />
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        textField: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
    }
}

RiskmgtLogPage.propTypes = {
    classes: PropTypes.object.isRequired,
    dataService: PropTypes.object,
}

export default hoc(styles)(RiskmgtLogPage)
